import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal, Spinner } from "react-bootstrap";
import { useWeb3React } from "@web3-react/core";

import { activateInjectedProvider, AppContext, connectors } from "./connectors";
import { checkSignInMethods, disconnectFirebase } from "./utils";
import { metaMaskIcon, walletConnect, close } from "../../assets";
import "./Modal.css";
import { createToUserProfile } from "../../actions/DataActions";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import messages from "../../utils/constants/messages";
import { CONNECTORS } from "../../utils/constants/config";

const WalletETHModal = ({ modalVisibility, closeModal }) => {
  const { activate, deactivate, active, account, library } = useWeb3React();

  const { setEithAuthToken, setEithProvider, values } = useContext(AppContext);
  const [state, setState] = useState({
    // metaMaskPresent: false,
    // metaMaskConnected: false,
    address: null,
    connecting: false,
    provider: null,
  });
  const setProvider = (type) => {
    setEithProvider(type);
  };

  const auth = getAuth();
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (active && state.connecting) {
        if (user) {
          createToUserProfile(user, account);
          setEithAuthToken(user?.accessToken);
          setState((state) => ({
            ...state,
            connecting: false,
          }));
          closeModal();
        } else {
          checkSignInMethods(account, library, values, {
            onError: (err) => {
              toast.error(err);
              handleDisconnectWallet();
              setState((state) => ({
                ...state,
                connecting: false,
              }));
            },
            sucssess: (user) => {
              // console.log("user:::",user);
              createToUserProfile(user, account);
              //TODO
              setEithAuthToken(user?.accessToken);
              setState((state) => ({
                ...state,
                connecting: false,
              }));
              closeModal();
            },
          });
        }
      }
    });

    if (active && state.provider) {
      setProvider(state.provider);
    }
    return unsubscribe;
  }, [auth, active, state.provider, state.connecting, library]);
  // useEffect(() => {
  //   if (active) {
  //     checkSignInMethods(account, {
  //       onError: (err) => {
  //         toast(err);
  //         handleDisconnectWallet();
  //         setState((state) => ({
  //           ...state,
  //           connecting: false,
  //         }));
  //       },
  //       sucssess: (user) => {
  //         // console.log("user:::",user);
  //         createToUserProfile(user, account);
  //         //TODO
  //         setEithAuthToken(user?.accessToken);
  //         setState((state) => ({
  //           ...state,
  //           connecting: false,
  //         }));
  //         closeModal();
  //       },
  //     });
  //   }
  // }, [active]);

  const connectMetaMask = async () => {
    if (window.ethereum) {
      if (state.connecting) return;

      setState((state) => ({
        ...state,
        connecting: true,
        provider: CONNECTORS.INJECTED,
      }));
      activateInjectedProvider("MetaMask");
      await activate(connectors.injected(), (err) => {
        setProvider("");
        if (
          err?.name == "UnsupportedChainIdError" ||
          err?.message?.includes("Unsupported chain")
        ) {
          toast.error(messages.invalid_network);
        } else {
          toast(err.message, { autoClose: 5000 });
        }

        setState((state) => ({
          ...state,
          connecting: false,
        }));
      });
    } else {
      window.open("https://metamask.io/download/", "_blank");
    }
  };

  const handleWalletConnectClick = async () => {
    if (state.connecting) return;
    setState((state) => ({
      ...state,
      connecting: true,
      provider: CONNECTORS.WALLET_CONNECT,
    }));

    await activate(connectors.walletConnect(values), (err) => {
      setProvider("");
      if (
        err?.name == "UnsupportedChainIdError" ||
        err?.message?.includes("Unsupported chain")
      ) {
        toast.error(messages.invalid_network);
      } else {
        toast(err.message, { autoClose: 5000 });
      }

      setState((state) => ({
        ...state,
        connecting: false,
      }));
    });
  };

  const handleDisconnectWallet = () => {
    deactivate();
    disconnectFirebase();
    setEithProvider(null);
    setEithAuthToken(null);
    closeModal();
  };

  // useEffect(() => {
  //   const isMetaMaskPresent = () => {
  //     return library?.provider?.isMetaMask ? true : false;
  //   };
  //   setState((state) => ({
  //     ...state,
  //     metaMaskPresent: isMetaMaskPresent() ? true : false,
  //   }));
  // }, [state.metaMaskConnected]);

  const connectCloseModalHandle = () => {
    if (active && state.connecting) {
      handleDisconnectWallet();
    }
    closeModal();
  };
  let connectModalJSX = () => {
    return (
      <>
        <div className="modal-caption text-center">
          <h3 className="title title-sm">Connect Your Wallet</h3>
          <p>Please select your wallet from the following list!</p>
        </div>
        <ul className="wallet-connect-container">
          <li
            className="wallet-connect"
            onClick={() => {
              connectMetaMask();
            }}
          >
            <div className="walletImg">
              <img src={metaMaskIcon} className="img-fluid" alt="land-sale" />
            </div>
            <span className="walletCaption">MetaMask</span>
            <br />
            {/* {state.metaMaskConnected && <span>Disconnect</span>}
            {!state.metaMaskPresent && (
              <span className="install">Not Installed</span>
            )} */}
          </li>

          <li className="wallet-connect" onClick={handleWalletConnectClick}>
            <div className="walletImg">
              <img src={walletConnect} className="img-fluid" alt="land-sale" />
            </div>

            <span className="walletCaption">WalletConnect</span>
          </li>

          {/* <li className="wallet-connect">
            <div className="walletImg">
              <img src={coinbase} className="img-fluid" alt="land-sale" />
            </div>

            <span className="walletCaption">coinbase</span>
          </li> */}

          {state.connecting && <Spinner size="lg" variant="border" />}
        </ul>
        <div className="mobile-btn">
          <button
            onClick={connectCloseModalHandle}
            className="custom-btn gray-bg lg"
          >
            Close
          </button>
        </div>
      </>
    );
  };
  let disconnectModalJSX = () => {
    return (
      <div className="content">
        <div className="modal-caption text-center">
          <h3 className="title title-sm">Disconnect Wallet?</h3>
          <p>
            Don’t worry. Disconnecting wallet won’t affect your in progress
            transactions!
          </p>
        </div>
        <div className="button-groups">
          <button
            className="custom-btn lg accent-bg"
            onClick={handleDisconnectWallet}
          >
            Yes
          </button>
          <button className="custom-btn lg gray-bg" onClick={closeModal}>
            No
          </button>
        </div>
      </div>
    );
  };
  return (
    <Modal
      show={modalVisibility}
      size="sm"
      // onAfterOpen={afterOpenModal}
      // onRequestClose={closeModal}
      dialogClassName="modal-dialog modal-dialog-centered"
      contentClassName={"customPopup ethWallet"}
    >
      <button type="button" className="close" onClick={connectCloseModalHandle}>
        {/* <img src={close} alt="close" /> */}
      </button>
      <div className="content">
        {active && !state.connecting ? disconnectModalJSX() : connectModalJSX()}
      </div>
    </Modal>
  );
};

export default WalletETHModal;
